import { render, staticRenderFns } from "./Addfrom.vue?vue&type=template&id=7c22f71a&"
import script from "./Addfrom.vue?vue&type=script&lang=js&"
export * from "./Addfrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports